function normalizeValues(sort) {
  if (!sort) {
    return [];
  }
  if (Array.isArray(sort.values)) {
    return sort.values;
  }
  if (sort.value) {
    return [{ value: sort.value, desc: !!sort.columnDescending }];
  }
  return [];
}

function findEntry(values, key) {
  return values.find((v) => v.value === key);
}

function flatSort(currentSort, headerValue) {
  const current = findEntry(normalizeValues(currentSort), headerValue);
  if (!current) {
    return { values: [{ value: headerValue, desc: false }], clearSort: false };
  }
  if (!current.desc) {
    return { values: [{ value: headerValue, desc: true }], clearSort: false };
  }
  return { values: [], clearSort: true };
}

export function computeNextSortState(
  currentSort,
  headerValue,
  hierarchyKeys = []
) {
  if (!hierarchyKeys.includes(headerValue)) {
    return flatSort(currentSort, headerValue);
  }

  const [primaryKey] = hierarchyKeys;
  const values = normalizeValues(currentSort);
  const primary = findEntry(values, primaryKey);

  if (headerValue === primaryKey) {
    if (!primary) {
      return { values: [{ value: primaryKey, desc: false }], clearSort: false };
    }
    if (!primary.desc) {
      return { values: [{ value: primaryKey, desc: true }], clearSort: false };
    }
    return { values: [], clearSort: true };
  }

  if (!primary) {
    return flatSort(currentSort, headerValue);
  }

  const secondary = findEntry(values, headerValue);
  if (!secondary) {
    return {
      values: [primary, { value: headerValue, desc: false }],
      clearSort: false
    };
  }
  if (!secondary.desc) {
    return {
      values: [primary, { value: headerValue, desc: true }],
      clearSort: false
    };
  }
  return { values: [primary], clearSort: false };
}

export function getDefaultSortState(hierarchyKeys = []) {
  if (hierarchyKeys.length === 0) {
    return { values: [], clearSort: true };
  }
  return {
    values: hierarchyKeys.map((key) => ({ value: key, desc: false })),
    clearSort: false
  };
}

export function resolveSortOnHierarchyChange(
  currentSort,
  newHierarchyKeys = [],
  oldHierarchyKeys = []
) {
  const currentValues = normalizeValues(currentSort).map((v) => v.value);
  const invalidated = currentValues.some(
    (v) => oldHierarchyKeys.includes(v) && !newHierarchyKeys.includes(v)
  );
  if (currentValues.length > 0 && !invalidated) {
    return currentSort;
  }
  return getDefaultSortState(newHierarchyKeys);
}

export function buildSortIconMap(currentSort) {
  const map = {};
  for (const entry of normalizeValues(currentSort)) {
    map[entry.value] = entry.desc ? "mdi-arrow-down" : "mdi-arrow-up";
  }
  return map;
}
